<template>
    <div v-if="ppeRegister">
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                    <img src="https://insync.software/mobile-img/logo.svg" class="h-12">
                    <div class="mt-4">
                        <p class="font-semibold mb-1">Hambro Roofing Limited</p>
                        <p>Unit 2, 6-10 Lamson Road Rainham Essex RM13 9YY</p>
                        <p><a href="tel:01708803930">01708 803 930</a></p>
                        <p><a href="http://www.hambroroofing.com">www.hambroroofing.com</a></p>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Date:</h2>
                            <p class="mt-1 text-gray-500">{{ ppeRegister.formattedDate }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Package:</h2>
                            <p class="mt-1 text-gray-500">{{ ppeRegister.packageName }}</p>
                        </div>
                        <div class="text-xl col-span-1 sm:col-span-2">
                            <h2 class="font-semibold text-gray-700">PPE Register reference:</h2>
                            <p class="mt-1 text-gray-500">{{ ppeRegister.ppeRegisterId }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 pb-16 lg:pb-16 flex flex-col-reverse lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 mb-12 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                    </div>
                </div>
                <div class="flex-1">
                    <div class="text-xl font-semibold text-gray-900 mt-4">PPE Register</div>
                    <div class="text-gray-700">
                        <table style="width:100%; border-collapse: collapse;margin-top:10px;">
                            <tr>
                                <td class="border border-gray-400 px-o py-1 bg-gray-50 text-xs w-16 text-center">
                                    Hard Hat
                                </td>
                                <td class="border border-gray-400 px-o py-1 bg-gray-50 text-xs w-16 text-center">
                                    Hi-Vis
                                </td>
                                <td class="border border-gray-400 px-o py-1 bg-gray-50 text-xs w-16 text-center">
                                    Boots
                                </td>
                                <td class="border border-gray-400 px-o py-1 bg-gray-50 text-xs w-16 text-center">
                                    Goggles
                                </td>
                                <td class="border border-gray-400 px-o py-1 bg-gray-50 text-xs w-16 text-center">
                                    Gloves
                                </td>
                                <td v-for="(equipment) in ppeRegister.otherEquipment" :key="equipment.id"
                                    class="border border-gray-400 pl-1 py-1 bg-gray-50 text-xs w-16">
                                    {{ equipment.name }}
                                </td>
                            </tr>
                            <tr>
                                <td class="border border-gray-400 px-2 py-1 text-center"
                                    v-text="ppeRegister.person.hardHat?'X':''"></td>
                                <td class="border border-gray-400 px-2 py-1 text-center"
                                    v-text="ppeRegister.person.highVisibilityVest?'X':''"></td>
                                <td class="border border-gray-400 px-2 py-1 text-center"
                                    v-text="ppeRegister.person.boots?'X':''"></td>
                                <td class="border border-gray-400 px-2 py-1 text-center"
                                    v-text="ppeRegister.person.googles?'X':''"></td>
                                <td class="border border-gray-400 px-2 py-1 text-center"
                                    v-text="ppeRegister.person.gloves?'X':''"></td>
                                <td v-for="(equipment) in ppeRegister.otherEquipment" :key="equipment.id"
                                    class="border border-gray-400 px-2 py-1 text-center"
                                    v-text="ppeRegister.person.selectedOtherEquipment[equipment.id]?'X':''"></td>
                            </tr>
                        </table>
                    </div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Given By</div>
                    <div class="text-gray-700 whitespace-pre-wrap"
                         v-text="ppeRegister.givenByName+' ('+ppeRegister.givenByPosition+')'"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Recieved By</div>
                    <div class="text-gray-700 whitespace-pre-wrap"
                         v-text="name"></div>
                    <div class="w-full flex align-middle justify-center" v-if="ppeRegister.signed">
                        <img :src="ppeRegister.signed" style="max-width:400px; width: 100%" class="border border-gray-200">
                    </div>
                    <div class="w-full flex align-middle justify-center" v-else>
                        <ui-button-new class="align-middle" icon="fas fa-pen" @click="addSignature" primary>Sign
                            {{ ppeRegister.signed ? 'again' : '' }} as {{ name }}
                        </ui-button-new>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {ExternalPPERegister} from '@models'
import UiDropdown from "../../../ui/UiDropdown.vue";
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDataGrid from "../../../ui/UiDataGrid.vue";
import UiDataGridItem from "../../../ui/UiDataGridItem.vue";
import ElementSizeSync from "../../../ui/ElementSizeSync";
import UiButtonNew from "../../../ui/UiButtonNew.vue";

export default {
    components: {UiButtonNew, ElementSizeSync, UiDataGridItem, UiDataGrid, UiDropdownItem, UiTextarea, UiDropdown},
    props: {
        ppeRegister: Object,
        personId: null,
        name: '',
    },
    data() {
        return {}
    },
    computed: {},
    methods: {
        addSignature() {
            this.$modals.sign({
                title: `Sign as "${this.name}"`,
                button: 'Confirmed',
                handle: async (data) => {
                    await Http.post(window.location.href, {signature: data.signature})
                    window.location.reload()
                }
            })
        },
    },
    async mounted() {
        if (this.id) {
            this.ppeRegister = await ExternalPPERegister.find(this.id);
        }
    },
}
</script>
